import { call, put, takeLeading, takeLatest, delay } from 'redux-saga/effects'
import {
  types,
  ICreateCapabilityAction,
  IGetCapabilityByIdAction,
  IUpdateCapabilityAction,
  IDeleteCapabilityAction,
  ICapability,
} from '../types/capability'
import { Modals } from '../types/modal'
import { push } from '../actions/router'
import * as actions from '../actions/capability'
import * as capabilitiesActions from '../actions/capabilities'
import { modalOpen } from '../actions/modal'
import { trace } from '../services/common'
import * as services from '../services/capability'
import { messages } from '../config/messages'

export function* createCapabilitySaga(action: ICreateCapabilityAction) {
  try {
    const capabilityData = yield call(
      services.createCapability,
      action.capabilityData
    )
    yield delay(0)
    yield put(
      actions.createCapabilitySuccess(
        capabilityData,
        messages.capabilityCreateSuccess
      )
    )
    yield put(capabilitiesActions.getCapabilities())
    yield delay(500) // show success message before redirect
    yield put(push('/settings/capabilities?tab=all-capabilities'))
  } catch (err) {
    trace(err)
    yield put(actions.createCapabilityFailure(err.message))
  }
}

export function* getCapabilitySaga(action: IGetCapabilityByIdAction) {
  try {
    const capabilityData: ICapability = yield call(
      services.getCapability,
      action.id
    )
    yield put(actions.getCapabilityByIdSuccess(capabilityData))
  } catch (err) {
    trace(err)
    if (err.code === 404) {
      yield put(push('/settings/capabilities?tab=all-capabilities'))
    }
    yield put(actions.getCapabilityByIdFailure(err.message))
  }
}

export function* updateCapabilitySaga(action: IUpdateCapabilityAction) {
  try {
    const capabilityData: ICapability = yield call(
      services.updateCapability,
      action.capabilityData
    )
    yield put(
      actions.updateCapabilitySuccess(
        capabilityData,
        messages.capabilityUpdateSuccess
      )
    )
    yield put(capabilitiesActions.getCapabilities())
    yield delay(500)
  } catch (err) {
    trace(err)
    if (err.code === 404) {
      yield put(push('/settings/capabilities?tab=all-capabilities'))
    }
    yield put(actions.updateCapabilityFailure(err.message))
  }
}

export function* deleteCapabilitySaga(action: IDeleteCapabilityAction) {
  try {
    yield call(services.deleteCapability, action.id)
    yield put(actions.deleteCapabilitySuccess(messages.capabilityDeleteSuccess))
    yield put(push('/settings/capabilities?tab=all-capabilities'))
  } catch (err) {
    trace(err)
    if (err.code === 404) {
      yield put(push('/settings/capabilities?tab=all-capabilities'))
    } else {
      yield put(modalOpen(Modals.deleteStatusModal))
    }
    yield put(actions.deleteCapabilityFailure(err.message))
  }
}

export function* capabilityWatcher() {
  yield takeLeading(types.CREATE_CAPABILITY__STARTED, createCapabilitySaga)
  yield takeLatest(types.GET_CAPABILITY_BY_ID__STARTED, getCapabilitySaga)
  yield takeLatest(types.UPDATE_CAPABILITY__STARTED, updateCapabilitySaga)
  yield takeLatest(types.DELETE_CAPABILITY__STARTED, deleteCapabilitySaga)
}
